<template>
  <div class="add-certificate-content">
    <el-card class="preview">
      <seal :seal="form" class="seal"></seal>
    </el-card>

    <el-card class="info">
      <div class="title">
        <h1 class="h1">选择背景</h1>
        <el-divider></el-divider>
      </div>

      <div class="image-shelves">
        <div class="image-item" v-for="item in backgroundImageList">
          <img class="background-image" :src="item" @click="changeBackground(item)"/>
          <i class="el-icon-circle-check" v-if="item === form.backgroundImage"></i>
        </div>
      </div>

      <div class="title">
        <h1 class="h1">其他信息</h1>
        <el-divider></el-divider>
      </div>

      <el-form ref="form" :model="form" :label-width="formLabelWidth" :rules="rules">
        <el-form-item label="证书名称" prop="title">
          <el-input style="width: 100%;" :size="componentSize" v-model="form.name"
                    placeholder="请输入名称" auto-complete="off" maxlength="20" clearable></el-input>
        </el-form-item>
        <el-form-item label="证书标题" prop="title">
          <el-input style="width: 100%;" :size="componentSize" v-model="form.title"
                    placeholder="请输入标题" auto-complete="off" maxlength="20" clearable></el-input>
        </el-form-item>
        <el-form-item label="证书正文" prop="mainBody">
          <el-input style="width: 100%;" :size="componentSize" v-model="form.mainBody"
                    placeholder="请输入正文" auto-complete="off" maxlength="100" clearable></el-input>
        </el-form-item>
        <el-form-item label="证书编号" prop="mainBody">
          <el-input style="width: 100%;" :size="componentSize" v-model="form.sn"
                    placeholder="请输入证书编号" auto-complete="off" maxlength="20" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addCertificate">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import seal from "./seal";

export default {
  name: "addCertificate",
  components: {seal},
  created() {
    this.form.backgroundImage = this.backgroundImageList[0]
  },
  data() {
    return {
      componentSize: '',
      rules: {
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "商品名称长度在1到20个字",
          },
        ],
        cover: [
          {
            required: true,
            message: "请上传封面",
            trigger: "change",
          }
        ],
        subjectId: [
          {
            required: true,
            message: "请选择科目",
            trigger: "change",
          }
        ],
        teacherId: [
          {
            required: true,
            message: "请选择讲师",
            trigger: "change",
          }
        ]
      },
      formLabelWidth: "80px",
      form: {
        title: '初级会计证书',
        mainBody: '张三，获得初级会计证书，以兹鼓励。',
        backgroundImage: ''
      },
      backgroundImageList: [
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1809008230366580736.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1809008230370775040.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1809008230358192128.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1809008230362386432.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1809008230353997824.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044571187253248.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044570952372224.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044567777284096.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044570507776000.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044568112828416.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044563943690240.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044561745874944.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044566426718208.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044565143261184.png",
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/1791044564572835840.png",
      ]
    }
  },
  methods: {
    addCertificate() {
      this.api.certificate.addCertificate(this.form).then(res => {
        if(res.success) {
          this.$message.success(res.message)
          this.$router.push({
            path: "/certificate",
          });
        } else {
          this.$message.error(res.message)
        }
      })
    },
    changeBackground(item) {
      this.form.backgroundImage = item
    },
    setComponentSize() {
      if (document.body.clientWidth <= 992) {
        this.componentSize = 'mini'
        return
      }
      if (document.body.clientWidth <= 1200) {
        this.componentSize = 'small'
        return
      }
      if (document.body.clientWidth <= 1920) {
        this.componentSize = 'medium'
      }
    },
  },
  mounted() {
    this.setComponentSize()
  }
}
</script>

<style lang="less" scoped>
.add-certificate-content {
  display: flex;

  .preview {
    position: relative;
    width: 45%;
    height: 100%;
    margin: 0 24px 0 0;

    .seal {
      width: 100%;
      height: 100%;
    }
  }

  .info {
    width: 45%;
    height: 100%;

    .image-shelves {
      display: flex;
      flex-wrap: wrap;

      .image-item {
        width: 80px;
        height: 120px;
        margin: 10px 10px;
        cursor: pointer;

        .background-image {
          width: 80px;
          height: 120px;
        }

        .el-icon-circle-check {
          position: relative;
          font-size: 32px;
          left: 24px;
          top: -76px;
          color: #409eff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/certificate/addCertificate.vue